import { render, staticRenderFns } from "./UcContractLifecycle.yaml?vue&type=template&id=72cdb118&component"
import script from "./UcContractLifecycle.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractLifecycle.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports